import React from 'react'
import { PageHeaderProps } from './PageHeader.types'
import { MdOutlineKeyboardBackspace } from 'react-icons/md'
import { useNavigate } from 'react-router'
import { useThemeFeatures } from '../../hooks/useThemeFeatures'
import { useTranslation } from 'react-i18next'
import styles from './PageHeader.module.css'

const PageHeader: React.FC<PageHeaderProps> = ({ title, onBack }) => {
  const navigate = useNavigate()
  const themeFeatures = useThemeFeatures()
  const { t } = useTranslation()

  return (
    <div
      className={`w-full mb-6 flex flex-row items-center justify-between ${styles.pageHeader}`}
    >
      <div
        onClick={onBack || (() => navigate(-1))}
        className={`flex items-center gap-2 cursor-pointer hover:opacity-80 transition-opacity ${styles.backButton}`}
      >
        <MdOutlineKeyboardBackspace className="text-xl text-[var(--heading-text)]" />
        {themeFeatures.showBackLabel && (
          <span className="text-[var(--heading-text)] font-medium">
            {t('common.back')}
          </span>
        )}
      </div>
      <h2
        className={`text-[var(--heading-text)] font-semibold text-lg flex-1 text-center ${styles.pageHeaderTitle}`}
      >
        {title}
      </h2>
      <div style={{ width: 24 }} /> {/* to balance layout spacing */}
    </div>
  )
}

export default PageHeader
